/**
 * Default module-level store + the `toast.*` API.
 *
 * `toast.error("…")` works from anywhere (query callbacks, interceptors, plain
 * modules) — no provider or hook required. Mount one host per platform
 * (`WebToastHost` / `NativeToastHost`) to render it.
 */

import { createToastStore } from "./store";
import type { ToastApi } from "./types";

export const toastStore = createToastStore();

export const toast: ToastApi = toastStore.api;
